import { render, staticRenderFns } from "./Ecommerce.vue?vue&type=template&id=02cd09cb&"
import script from "./Ecommerce.vue?vue&type=script&lang=js&"
export * from "./Ecommerce.vue?vue&type=script&lang=js&"
import style0 from "./Ecommerce.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports